<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />			
			<vs-row class="pt-5">
				<div class="w-1/3 md:px-3">
					<div class="w-full mb-5">
						<vs-input 
								autocomplete="off"
								v-validate="'required'" 
								label="Amount" 
								name="amount" 
								type="number"
								v-model="models.amount" 
								@keypress="isNumber($event)"
								class="w-full"/>
						<span class="text-danger text-sm" v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
					</div>
					<div class="w-full">
						<vs-textarea label="Note" v-model="models.notes" rows="6"/>
					</div>
				</div>
			</vs-row>

			<div slot="footer" class="justify-center">
				<vs-button button="submit" color="primary" type="filled" class="mr-3">Save</vs-button>
				<vs-button @click="$router.go(-1)" color="rgb(172,172,172)" type="border">Cancel</vs-button>
			</div>
		</vs-card>
	</form>
</template>

<script>
	export default {
		name: 'FormCoinHistory',
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
				},
				models: {
                    userId: this.$route.params.userId,
					amount: '',
					notes: '',
				},
				vars: {},
			}
		},
		created() {
			this.getById();
		},
		methods: {
			getById() {
				if (this.$route.params.id) {
					this.$axios.get(`brand-ambasador/coins/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							this.models.amount = data.amount;
							this.models.notes = data.notes;
                            delete this.models.userId;
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},

			isNumber($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if ((keyCode < 48 || keyCode > 57) && keyCode !== 45) {
					$event.preventDefault();
				}
			},
			save() {
				this.$validator.validate().then(async valid => {
					if (valid) {
						let request = "";
						let message = "create"

						if (!this.$route.params.id) {
							request = this.$axios.post('brand-ambasador/coins', this.models);
						} else {
							message = "update"
							request = this.$axios.put(`brand-ambasador/coins/${this.$route.params.id}`, this.models);
						}
						request
							.then(() => {
								this.$showToast('Success', `Success ${message} Tiers`,)
								this.$router.go(-1)
							})
							.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>